import { patientAssessmentsClient } from '@/api/patients/patientAssessmentsClient';
import type { UpdatePatientAssessmentBodyDto } from '@montugroup/pms-api-contracts';

export const useUpdatePatientAssessment = () => {
  const { mutateAsync, ...rest } = patientAssessmentsClient().updatePatientAssessment.useMutation();

  const updatePatientAssessment = async (
    payload: UpdatePatientAssessmentBodyDto
  ): Promise<{
    status: number;
    body: string;
  }> => {
    const response = await mutateAsync({
      params: {
        id: payload.id
      },
      body: {
        data: payload
      }
    });

    const { status, body } = response;

    return { status, body };
  };

  return { updatePatientAssessment, ...rest };
};
